require('initializers/gettext').default(__TRANSLATIONS__.gettext.de); // eslint-disable-line no-undef
require('initializers/i18n').default('de', __TRANSLATIONS__.i18n.de); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/de');
require('jquery-ui/ui/i18n/datepicker-de');
require('moment/locale/de');
require('dayjs/locale/de');
